import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { CdkDragEnd } from '@angular/cdk/drag-drop';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { take, takeUntil } from 'rxjs/operators';
import { combineLatest, Subject } from 'rxjs';
import { VisaDesignerService } from '../visa-designer.service';
import { ComponentLoaderComponent } from '../component-loader/component-loader-component';
import { ImagilityBaseResponse } from 'app-models';
import * as fromVDTask from '../vd-state/reducers/vd.reducer';
import { Store } from '@ngrx/store';
import { SignatureUploadComponent } from '../../shared/signature-upload/signature-upload.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'environment-configurations';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Component({
  selector: 'app-timeline-create-steps-component',
  templateUrl: './vd-builder-timeline-create-steps.component.html',
  styleUrls: ['../visa-designer.scss', './vd-builder-timeline-create-steps.component.scss'],
})
export class VdBuilderTimelineCreateStepsComponent implements OnInit, OnDestroy {
  @ViewChild(ComponentLoaderComponent) componentLoader!: ComponentLoaderComponent;

  placeHolderObj = { 'controlType': 'STANDARD' };
  placeHolderCustom = { 'controlType': 'CUSTOM' };
  emailComp;
  palette: any = {};
  paletteIndex: any = 0;
  // addForm: FormGroup;
  titlePalette: any;
  displayPalette = false;
  addForm = new FormGroup({});
  column: any = 4;
  backgroundColor: any;
  borderColor: any;
  htmlRenderObj: any = [];
  placeHolderStandardArray = [];
  placeHolderCustomArray = [];
  placeHolderFilter: string;
  data: any = {};
  user = false;
  components: any = [];
  url: any;
  visaId: any;
  finalData: any = {};
  printData: any = {};
  observableSubscription$ = new Subject();
  customStepData: any = [];
  resultObj: any = [];
  customStepId: any = localStorage.getItem('customStepId');

  dragCurrentData: any;
  dropCurrentData: any;
  dropEve: any = [];
  displayBasic = false;
  formName: any;
  offset: any;
  showTabs: any = 'general';
  visaType: any;
  typeOfButton: string;
  selectedStep = null;
  editMode = false;
  coorsArray: any = [];
  isPreview = false;
  dataSources: any[] = [];
  listDocumentReferenceData: any[] = [];
  gridProperties = [{
    columnName: 'Column Name',
    columnDef: 'colDef',
    columnType: 'text',
    columnOption: '',
    hideFromList: false
  }];
  formTypeList: any;
  newOption: string;
  columnWidth = [
    { value: 12, label: 'Full page width' },
    { value: 8, label: 'Two-third page width' },
    { value: 6, label: 'Half page width' },
    { value: 4, label: 'One-third page width' },
  ];
  showFirstMenu = true;
  visaInfo: any;
  prePDFToWorkflow: boolean;
  isView: boolean = false;
  actionButton: any;
  userImage: any;
  labelNotNeededArray = ["CustomCalenderComponent", "AddressDetailsComponent", "VdSwitchGroupComponent", "CustomQuestionsGroupComponent", "VdLabelComponent", "VdDividerComponent", "VdTextAreaComponent", "CustomGridEditor", "CustomTextFieldComponent", "VdEadLibraryComponent", "VdAddGenerateFormComponent", "DOC_UPLOAD", "PERSON_DTL", "CommonEditorComponent", "VdCountryStateComponent", "CustomButtonComponent","VdPhoneComponent","CustomDateTimePickerComponent","CustomDropdownComponent"];
  isEditVisa:boolean = false;
  
  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private cRef: ChangeDetectorRef,
    private VDService: VisaDesignerService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private store: Store<any>,
    private dialog: MatDialog,) {
    combineLatest([
      this.store.select(fromVDTask.getVDVisaInfo),
      this.store.select(fromVDTask.getVDBuildType)
    ])
      .pipe(take(1))
      .subscribe((response: any[]) => {
        this.visaInfo = response[0];
        this.prePDFToWorkflow = response[1] && response[1] === 'old';
      });
  }
  ngOnInit() {
    const getUrl = this.router.url;
    const splitUrl = getUrl.split('/');
    this.url = splitUrl[6];
    this.column = 4;
    this.visaId = localStorage.getItem('visaId');
    this.selectedStep = localStorage.getItem('selectedStep');
    this.VDService.getPlaceHolderControls(this.placeHolderObj).subscribe(data => {
      this.placeHolderStandardArray = data.data;
      // this.placeHolderStandardArray.push(this.actionButton);
    });
    this.VDService.getPlaceHolderControls(this.placeHolderCustom).subscribe(data => {
      this.placeHolderCustomArray = this.customFormRadioImage(data.data);
    });
    this.VDService.getDataSources().subscribe(response => {
      this.dataSources = response.data;
    });
    this.getAllDocumentTypes();
    this.getAllFormTypes();
    try {
      this.getTemplate(); 
    } catch (error) {
      console.log("template error",error);
    }
  
    this.route.params.subscribe((params) => {
      this.isView = (params['isView'] === 'view') ? true : false;
    });
    this.isEditVisa = localStorage.getItem('isEditVisa') === 'true' ? true : false;
  }

  customFormRadioImage(data) {
    data.forEach((item) => {
      if (item.layoutCode == "CustomFormRadioButtonComponent") {
        item.properties.inputArray.forEach((res) => {
          if (!res.imgUrl) {
            res.imgUrl = '/assets/userIcon.png';
          }
        });
      }
    });

    return data;
  }

  mouseEnter(item: any, index: number) {
    item.hover = true;
    // document.getElementById(String(index)).scrollIntoView({ behavior: "smooth", block: "start" });
  }

  mouseLeave(item: any) {
    item.hover = false;
  }

  getTemplate(isAfterSave: boolean = false) {
    this.htmlRenderObj = [];
    this.VDService.getTaskDetailsTemplates(this.visaId).subscribe((response: any) => {
      this.visaType = response?.data?.visaType?.code || null;
      if (JSON.parse(response.data.stepJson) != null) {
        this.resultObj = JSON.parse(response.data.stepJson);
        if (this.resultObj[this.customStepId].controlArray !== null || this.resultObj[this.customStepId].controlArray != undefined) {
          const x: any[] = this.resultObj[this.customStepId].controlArray;
          if (x && x.length > 0) {
            if (!isAfterSave && !this.prePDFToWorkflow) {
              this.htmlRenderObj = this.calcRowsColumns(JSON.parse(JSON.stringify(x)));
              if (JSON.stringify(this.htmlRenderObj) !== JSON.stringify(x)) {
                this.resultObj[this.customStepId]['controlArray'] = [...this.htmlRenderObj];
                const payload = {
                  stepJson: JSON.stringify(this.resultObj),
                  visaId: this.visaId
                };
                this.VDService.createVisa(payload)
                  .pipe(takeUntil(this.observableSubscription$))
                  .subscribe((response) => {
                    // return true;
                  });
              }
            } else {
              this.htmlRenderObj = [...x];
            }
          }

          if (!this.prePDFToWorkflow) {
            this.VDService.visaType = '';
            this.VDService.currentStepName = '';
            this.VDService.buildStepsSelectedData = [];
          }
          this.cRef.detectChanges();
        }
      }
    });
  }

  deleteAllControls() {
    this.resultObj[this.customStepId]['controlArray'] = [];
    const payload = {
      stepJson: JSON.stringify(this.resultObj),
      visaId: this.visaId
    };
    this.VDService.createVisa(payload)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response) => {
        this.getTemplate(true);
        return true;
      });
  }

  calcRowsColumns(htmlRenderObj: any[]) {
    const buildStepsSelectedDataNew = [];
    let rowVal: number;
    const noEmptyColHtmlRenderObj = htmlRenderObj.filter(x => !x.emptyCol);
    const finishedRows = [];
    const rows = Array.from(new Set(noEmptyColHtmlRenderObj.filter(x => x.numberOfRow).map(x => x.numberOfRow)))
      .sort((a, b) => a - b);
    const arrangedNoEmptyColHtmlRenderObj = [];
    rows.forEach(x => {
      arrangedNoEmptyColHtmlRenderObj.push(...noEmptyColHtmlRenderObj.filter(y => y.numberOfRow === x));
    });
    arrangedNoEmptyColHtmlRenderObj.push(...noEmptyColHtmlRenderObj.filter(x => !x.numberOfRow));
    arrangedNoEmptyColHtmlRenderObj
      .forEach((control: any, i: number) => {
        if (!control.numberOfRow ||
          (control.numberOfRow && !finishedRows.includes(control.numberOfRow))) {
          if (rowVal) {
            if (control.numberOfRow) {
              if (rowVal !== control.numberOfRow) {
                buildStepsSelectedDataNew.push({
                  emptyCol: true
                });
                rowVal = control.numberOfRow;
              }
            } else {
              buildStepsSelectedDataNew.push({
                emptyCol: true
              });
              rowVal = null;
            }
          } else {
            if (control.numberOfRow) {
              if (rowVal === null) {
                buildStepsSelectedDataNew.push({
                  emptyCol: true
                });
              }
              rowVal = control.numberOfRow;
            } else {
              rowVal = null;
            }
          }
          if (control.numberOfRow) {
            buildStepsSelectedDataNew.push(...arrangedNoEmptyColHtmlRenderObj.filter(x => x.numberOfRow === control.numberOfRow));
            finishedRows.push(control.numberOfRow);
          } else {
            buildStepsSelectedDataNew.push(control);
          }
        }
      });
    return buildStepsSelectedDataNew;
  }

  removeBox(index: any, name?: string) {
    this.confirmationService.confirm({
      message: `Are you sure you want to delete${name ? ' ' + name : ''}?`,
      header: 'Delete',
      accept: () => {
        this.htmlRenderObj.splice(index, 1);
        this.displayPalette = false;
        this.toastr.success('You have succcessfully deleted the "Component"', 'Success');
        if (!this.prePDFToWorkflow) {
          this.htmlRenderObj = this.calcRowsColumns(this.htmlRenderObj);
        }
        this.resultObj[this.customStepId]['controlArray'] = this.htmlRenderObj;
        const payload = {
          stepJson: JSON.stringify(this.resultObj),
          visaId: this.visaId
        };
        // var stringObj = JSON.stringify(this.htmlRenderObj);
        //   let postObj = {
        //       "stepJson": stringObj,
        //       "visaId": this.visaId,
        //   }

        this.VDService.saveTaskDetailsTemplates(payload).subscribe(res => {
          this.toastr.success('You have succcessfully deleted', 'Success');
          return res;
        });
      },
      reject: () => {
      }


    });
  }

  getAllFormTypes() {
    const payload = {
      petitionType: '',
      taskTypeRef: '',
      visaType: ''
    };
    this.VDService.getFormTypes(payload)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: ImagilityBaseResponse) => {
        this.formTypeList = Object.assign([], response.data);
      });

  }

  cancelTemplate(event) {
    this.htmlRenderObj = [];
  }

  hadleCancel() {
    this.router.navigate([`../timeline-steps`], { queryParams: { id: this.visaId }, relativeTo: this.route });
  }

  createForm() {
    this.addForm = this.fb.group(this.finalData);
  }
  ngOnDestroy() {
    this.htmlRenderObj = null;
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

  // Drag and Drop Custom and Standard Component
  onDragEnd(event, data) {

    if (data.layoutCode === 'CustomTextFieldComponent') {
      data.value = { checkbox_val: false, textFieldVal: '' };
    }
    if (data.layoutCode === 'CustomQuestionsGroupComponent' || data.layoutCode === 'VdSwitchGroupComponent') {
      data.value = null;
    }

    if (data.label) {
      data.name = data.label.toUpperCase().replace(/ /g, '_') + '_' + this.uuid();
      data.groupName = data.name;
    } else {
      data.name = this.uuid();
      data.groupName = data.name;
    }

    data.coordinateY = 0;
    data.coordinateX = 0;

    if (data.properties && data.properties.isDataFromApi) {
      this.VDService.getDataSources().subscribe(response => {
        this.dataSources = response.data;
      });
    }
    // this.htmlRenderObj.push(z);
    this.htmlRenderObj.push(JSON.parse(JSON.stringify(data)));
    this.VDService.getPlaceHolderControls(this.placeHolderCustom).subscribe(dataPlaceHolderControls => {
      this.placeHolderCustomArray = this.customFormRadioImage(dataPlaceHolderControls.data);
    });
    if (!this.prePDFToWorkflow) {
      this.correctStructureAndSavePostDragAndDrop();
    }
    this.cRef.detectChanges();
  
  }

  correctStructureAndSavePostDragAndDrop() {
    this.htmlRenderObj = this.calcRowsColumns(this.htmlRenderObj);
    this.resultObj[this.customStepId]['controlArray'] = [...this.htmlRenderObj];
    const payload = {
      stepJson: JSON.stringify(this.resultObj),
      visaId: this.visaId
    };
    this.VDService.createVisa(payload)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response) => {
        return true;
      });
  }

  // Drag and Drop Right Panel Component
  dragEnd(event: CdkDragEnd, index, _data) {
    if (!this.prePDFToWorkflow) {
      if (_data.coordinateX == null) {
        _data.coordinateX = 0;
      }
      if (_data.coordinateY == null) {
        _data.coordinateY = 0;
      }
    }
    this.offset = { ...(<any>event.source._dragRef)._passiveTransform };
    this.editMode = _data.editMode;
    if (_data.editMode) {
      const el = document.getElementById(index);
      const arr = el.style.transform.replace(/[\(\)translate,px ]/gi, ' ');
      const arr1 = arr.replace(/ +/gi, ' ').trim().split(' ');
      const newX = Number(arr1[1]);
      const newY = Number(arr1[2]);
      const oldX = _data.coordinateX;
      const oldY = _data.coordinateY;
      const calculatXCoords = parseFloat(oldX) + newX;
      const calculatYCoords = parseFloat(oldY) + newY;
      this.addCoordinates(calculatXCoords, calculatYCoords, _data, index);
    }
    else {
      this.htmlRenderObj[index]['coordinateX'] = this.offset.x;
      this.htmlRenderObj[index]['coordinateY'] = this.offset.y;
    }
  }


  addCoordinates(calculatXCoords, calculatYCoords, _data, index) {
    if (this.coorsArray.length == 0) {
      this.coorsArray.push({ 'coordinateX': calculatXCoords, 'coordinateY': calculatYCoords, 'name': _data.name });
    }
    else {
      const getIdx = this.coorsArray.map((el) => {
        return el.name;
      }).indexOf(this.htmlRenderObj[index].name);

      if (getIdx >= 0) {
        this.coorsArray[getIdx]['coordinateX'] = calculatXCoords;
        this.coorsArray[getIdx]['coordinateY'] = calculatYCoords;
      }
      else {
        this.coorsArray.push({ 'coordinateX': calculatXCoords, 'coordinateY': calculatYCoords, 'name': _data.name });
      }
    }
  }

  // open settings palette
  openPalette(index) {
    this.palette = {};
    this.paletteIndex = index;
    this.showTabs = 'general';
    this.displayPalette = true;
    this.palette = this.htmlRenderObj[index];
    this.showFirstMenu = true;
    this.palette.hover = false;
    if (!this.prePDFToWorkflow) {
      if (this.palette.numberOfRow && this.palette.numberOfColumn) {
        this.palette.isRowColumn = true;
      } else {
        this.palette.isRowColumn = false;
        this.palette.numberOfRow = null;
        this.palette.numberOfColumn = null;
      }
    }
    if (this.palette.layoutCode === 'CustomCheckboxComponent') {
      if (this.palette.properties &&
        this.palette.properties.inputArray && this.palette.properties.inputArray.length > 0) {
        (this.palette.properties.inputArray as any[]).forEach(x => {
          if (typeof x === 'string') {
            x = {
              isEdit: false,
              name: x,
              isChecked: false,
              data_field_name: this.uuid()
            };
          } else if (typeof x === 'object') {
            x = {
              ...x,
              isEdit: false
            };
          }
        });
        this.palette.value = [...this.palette.properties.inputArray];
      } else {
        this.palette.properties.inputArray = [];
        this.palette.value = [];
      }
    } else if (this.palette.layoutCode === 'CustomRadioButtonComponent') {
      if (this.palette.properties &&
        this.palette.properties.inputArray && this.palette.properties.inputArray.length > 0) {
        this.palette.properties.inputArray = (this.palette.properties.inputArray as any[]).map(x => {
          const uuid = this.uuid();
          if (typeof x === 'string') {
            return {
              code: uuid,
              name: x,
              isEdit: false,
              data_field_name: uuid
            };
          } else if (typeof x === 'object') {
            return {
              ...x,
              code: x.data_field_name ? x.data_field_name : uuid,
              name: x.name,
              isEdit: false
            };
          }
        });
        this.palette.value = [...this.palette.properties.inputArray];
      } else {
        this.palette.properties.inputArray = [];
        this.palette.value = [];
      }
    } else if (this.palette.layoutCode === 'CustomFormRadioButtonComponent') {
      this.palette.properties.isDataFromApi = false;
      if (this.palette.properties &&
        this.palette.properties.inputArray && this.palette.properties.inputArray.length > 0) {
        this.palette.properties.inputArray = (this.palette.properties.inputArray as any[]).map(x => {
          const uuid = this.uuid();
          if (typeof x === 'string') {
            return {
              code: uuid,
              name: x,
              isEdit: false,
              data_field_name: uuid
            };
          } else if (typeof x === 'object') {
            return {
              ...x,
              code: x.data_field_name ? x.data_field_name : uuid,
              name: x.name,
              isEdit: false,
              imgUrl: x.imgUrl
            };
          }
        });
        this.palette.value = [...this.palette.properties.inputArray];
      } else {
        this.palette.properties.inputArray = [];
        this.palette.value = [];
      }
    } else if (this.palette.layoutCode === 'CustomButtonActionComponent') {
      if (this.palette.properties &&
        this.palette.properties.inputArray && this.palette.properties.inputArray.length > 0) {
        this.palette.properties.inputArray = (this.palette.properties.inputArray as any[]).map(x => {
          const uuid = this.uuid();
          if (typeof x === 'object') {
            return {
              ...x,
              code: x.data_field_name ? x.data_field_name : uuid,
              name: x.name,
              isEdit: false,
              url: x.url,
            };
          }
        });
        this.palette.value = [...this.palette.properties.inputArray];
      } else {
        this.palette.properties.inputArray = [];
        this.palette.value = [];
      }
    }
    if (!this.palette.gridProperties || this.palette?.gridProperties.length === 0) {
      this.palette.gridProperties = this.gridProperties;
      this.palette.gridValues = [];
    }

    if (!this.palette.coordinateY) {
      this.palette.coordinateY = 0;
    }

    if (!this.palette.coordinateX) {
      this.palette.coordinateX = 0;
    }

    if (this.palette.layoutCode === 'VdSwitchGroupComponent') {
      if (!this.palette.groupElementProperty) {
        this.palette.groupElementProperty = {
          questionLabel: '',
          textAreaLabel: '',
          labelStyle: {
            width: ''
          },
          textAreaStyle: {
            width: ''
          },
          whenTextAreaShown: 'on',
          isTwostate: false,
          //options: this.defaultSwitchOptions
        }
      } else {
        this.palette.groupElementProperty = {
          ...this.palette.groupElementProperty,
          questionLabel: this.palette.groupElementProperty.questionLabel ? this.palette.groupElementProperty.questionLabel : '',
          textAreaLabel: this.palette.groupElementProperty.textAreaLabel ? this.palette.groupElementProperty.textAreaLabel : '',
          labelStyle: this.palette.groupElementProperty.labelStyle ? {
            ...this.palette.groupElementProperty.labelStyle,
            width: this.palette.groupElementProperty.labelStyle.width ? this.palette.groupElementProperty.labelStyle.width : ''
          } : {
            width: ''
          },
          textAreaStyle: this.palette.groupElementProperty.textAreaStyle ? {
            ...this.palette.groupElementProperty.textAreaStyle,
            width: this.palette.groupElementProperty.textAreaStyle.width ? this.palette.groupElementProperty.textAreaStyle.width : ''
          } : {
            width: ''
          },
          whenTextAreaShown: this.palette.groupElementProperty.whenTextAreaShown ? this.palette.groupElementProperty.whenTextAreaShown : 'on',
          isTwostate: this.palette.groupElementProperty.isTwostate ? this.palette.groupElementProperty.isTwostate : false,
          //options: this.palette.groupElementProperty.options ? this.palette.groupElementProperty.options : this.defaultSwitchOptions
        }
      }
    }
    this.cRef.detectChanges();
  }

  uuid() {
    const val1 = Date.now().toString(36);
    const val2 = Math.random().toString(36).substring(2);
    return val1 + val2;
  }

  deleteField() {
    this.htmlRenderObj.splice(this.paletteIndex, 1);
  }

  // close settings palette
  closePaletter() {
    this.displayPalette = false;
  }

  onOptionItemDelete(index: number) {
    this.palette.value.splice(index, 1);
  }

  addOptionItem() {
    if (this.palette.layoutCode === 'CustomFormRadioButtonComponent') {
      this.palette.value.push({
        name: this.newOption,
        isChecked: false,
        isEdit: false,
        imgUrl: '/assets/userIcon.png'
      });
    } else {
      this.palette.value.push({
        name: this.newOption,
        isChecked: false,
        isEdit: false,
      });
    }
    this.newOption = null;
  }

  onOptionItemEditClose(item: any) {
    item.name = item.preEditValue.trim();
    item.isEdit = true;
  }

  fileChangeEvent(event: any) {
    console.log(event);
  }

  onOptionItemEdit(item: any) {
    item.preEditValue = item.name.trim();
    item.isEdit = true;
  }

  // onKeyDown(event) {
  //   if (event.originalEvent.key === 'Enter' || event.originalEvent.key === ',') {
  //     this.palette.value = [...this.palette.value, { name: event.value, isChecked: false }];
  //     this.palette.properties.inputArray = [...this.palette.value, { name: event.value, isChecked: false }];
  //     for (let i = 0; i < this.palette.value.length; i++) {
  //       if (typeof this.palette.value[i] === 'string') {
  //         this.palette.value.splice(i, 1);
  //       }
  //       this.palette.properties.inputArray = this.palette.value;
  //     }
  //   }
  // }

  removeChip(event) {
    if (this.palette.value && this.palette.value.length > 0) {
      const getIndex = this.palette.value.map(item => {
        return item.name;
      }).indexOf(event.value.name);
      if (getIndex !== -1) {
        this.palette.value.splice(getIndex, 1);
      }
    }
  }

  onRowColumnChange() {
    this.palette.coordinateX = 0;
    this.palette.coordinateY = 0;
    const coorsObj = this.coorsArray.find(c => c.name === this.palette.name);
    if (coorsObj) {
      coorsObj.coordinateX = 0;
      coorsObj.coordinateY = 0;
    } else {
      this.coorsArray.push({
        coordinateX: 0,
        coordinateY: 0,
        name: this.palette.name
      });
    }
    if (this.palette.layoutCode === 'VdCountryStateComponent') {
      this.palette.groupElementProperty.countryStyle.width = '100%';
      this.palette.groupElementProperty.stateStyle.width = '100%';
    }
    if (this.palette.isRowColumn) {
      this.palette.style.width = '100%';
      // const allRows = this.htmlRenderObj[this.VDService.currentStepName]?.controlArray.filter(row => row.numberOfRow).map(row => Number(row.numberOfRow));
      const allRows = this.htmlRenderObj.filter(row => row.numberOfRow).map(row => Number(row.numberOfRow));
      let maxRow: number = 0;
      if (allRows && allRows.length > 0) {
        maxRow = Math.max(...allRows);
      }
      this.palette.numberOfRow = maxRow + 1;
      this.palette.numberOfColumn = 4;
    } else {
      this.palette.style.width = 'auto';
      this.palette.numberOfRow = null;
      this.palette.numberOfColumn = null;
    }
  }

  // save settings palette
  saveSetting() {
    if (this.isView) {
      return;
    }
    if (this.palette.style == null) {
      this.palette.style = { width: '' };
    }
    if (this.palette.layoutCode === 'VdAddGenerateFormComponent') {
      this.palette.properties.formTypeArray = [];
      this.palette.properties.formTypeArray = this.palette.properties.selectedFormTypes.map((item) => {
        return {
          formType: item.code,
          formTypeDisplayName: item.description,
          generateFormFor: []

        };
      });
    }
    if (this.palette.layoutCode === 'CustomQuestionsGroupComponent' || this.palette.layoutCode === 'VdSwitchGroupComponent') {
      this.palette.value = null;
    }

    if (this.palette.properties && this.palette.properties.isDataFromApi) {
      this.palette.properties.inputArray = [];
    }
    if (this.palette?.properties?.inputArray?.length > 0 || this.palette?.value?.length > 0) {
      if (this.palette.layoutCode === 'CustomCheckboxComponent' ||
        this.palette.layoutCode === 'CustomRadioButtonComponent' || this.palette.layoutCode === 'CustomButtonActionComponent' ||
        this.palette.layoutCode === 'CustomFormRadioButtonComponent') {
        if (this.palette.value && this.palette.value.length > 0) {
          if (this.palette.layoutCode === 'CustomFormRadioButtonComponent') {
            this.palette.properties.inputArray.forEach((item) => {
              if (!item.imgUrl) {
                item.imgUrl = '/assets/userIcon.png';
              }
            });
          }
          this.palette.properties.inputArray = [...this.palette.value];

          this.palette.properties.inputArray = this.palette.properties.inputArray.map(i => {
            i.name = i.name.trim();
            return i;
          });

        } else {
          this.palette.properties.inputArray = [];
          this.palette.value = [];
        }
      } else {
        if (this.palette.layoutCode !== 'CustomDropdownComponent'){
          this.palette.properties.inputArray = this.palette.properties.inputArray.map(i => i.trim());
          this.palette.value = [...this.palette.properties.inputArray];
        }else{
          this.palette.properties.inputArray = this.palette.properties.inputArray.map(i => i.trim());
          this.palette.value = null;
        }
        
      }
    } else if (this.palette.properties) {
      this.palette.properties.inputArray = [];
      this.palette.value = [];
    }


    this.htmlRenderObj[this.paletteIndex] = {
      ...this.palette,
      id: this.palette.id ? this.palette.id : null,
      stepTypeId: this.palette.stepTypeId ? this.palette.stepTypeId : 182
    };

    // this.cRef.detectChanges();

    for (let i = 0; i < this.coorsArray.length; i++) {
      const getIndex = this.htmlRenderObj.map((item) => {
        return item.name;
      }).indexOf(this.coorsArray[i].name);
      if (getIndex >= 0) {
        this.htmlRenderObj[getIndex]['coordinateX'] = this.coorsArray[i]['coordinateX'];
        this.htmlRenderObj[getIndex]['coordinateY'] = this.coorsArray[i]['coordinateY'];
      }
    }

    for (let i = 0; i < this.htmlRenderObj.length; i++) {
      this.htmlRenderObj[i].editMode = true;
    }
    if (!this.prePDFToWorkflow) {
      this.htmlRenderObj = this.calcRowsColumns(this.htmlRenderObj);
    }
    this.resultObj[this.customStepId]['controlArray'] = this.htmlRenderObj;

    const payload = {
      stepJson: JSON.stringify(this.resultObj),
      visaId: this.visaId
    };
    this.VDService.createVisa(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      if (response && response.status === 200) {

        // this.VDService.visaType = ''
        this.getTemplate(true);
        this.toastr.success('Step controller is successfully saved', 'Success');

        //  localStorage.setItem('customStepId', null);
        //  this.router.navigate([`../timeline-steps`], { queryParams: {id: this.visaId}, relativeTo: this.route });
        return false;
      }
    });
  }

  onChangeOfOption(palette) {
    this.palette = palette;
    if (this.palette.properties.isDataFromApi) {
      this.palette.properties.inputArray = [];
    }
  }

  // save steps setting ---- backend API Call
  onSubmit(event) {
    if (this.isView) {
      return;
    }
    const count = document.querySelectorAll('.elementCount');
    if (count.length > 45) {
      CustomErrorToastComponent.showErrorToast(this.toastr, 'You can not add more then 45 fields');
      return false;
    }

    if (this.editMode) {
      for (let i = 0; i < this.coorsArray.length; i++) {
        const getIndex = this.htmlRenderObj.map((item) => {
          return item.name;
        }).indexOf(this.coorsArray[i].name);
        if (getIndex >= 0) {
          this.htmlRenderObj[getIndex]['coordinateX'] = this.coorsArray[i]['coordinateX'];
          this.htmlRenderObj[getIndex]['coordinateY'] = this.coorsArray[i]['coordinateY'];
        }
      }
    }

    for (let i = 0; i < this.htmlRenderObj.length; i++) {
      this.htmlRenderObj[i].editMode = true;
      this.htmlRenderObj[i].id = this.htmlRenderObj[i].id ? this.htmlRenderObj[i].id : null;
      this.htmlRenderObj[i].stepTypeId = this.htmlRenderObj[i].stepTypeId ? this.htmlRenderObj[i].stepTypeId : 182;
      if (this.htmlRenderObj[i].layoutCode === 'CustomQuestionsGroupComponent' || this.htmlRenderObj[i].layoutCode === 'VdSwitchGroupComponent') {
        this.htmlRenderObj[i].value = null;
      }
    }
    if (!this.prePDFToWorkflow) {
      this.htmlRenderObj = this.calcRowsColumns(this.htmlRenderObj);
    }
    this.resultObj[this.customStepId]['controlArray'] = this.htmlRenderObj;
    this.resultObj[this.customStepId].id = this.resultObj[this.customStepId].id ? this.resultObj[this.customStepId].id : null;
    this.resultObj[this.customStepId].stepTypeId = this.resultObj[this.customStepId].stepTypeId ? this.resultObj[this.customStepId].stepTypeId : 182;
    const payload = {
      stepJson: JSON.stringify(this.resultObj),
      visaId: this.visaId
    };
 //   console.log(payload);
    this.VDService.createVisa(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      if (response && response.status === 200) {
        this.toastr.success('Step controller is successfully saved', 'Success');
        localStorage.setItem('customStepId', null);
        this.router.navigate([`../timeline-steps`], { queryParams: { id: this.visaId }, relativeTo: this.route });
        return false;
      }
    });
  }

  backSetting() {
    this.displayPalette = false;
  }

  tabs(val) {
    this.showTabs = val;
  }

  requiredValidation(event) {
    this.palette.mandatory = event.checked;
  }

  hideField(event) {

  }

  handleReadonlySwitch(event) {
    this.palette.readonly = event.checked;
  }
  handleIsMultiselectChange(e) {

  }

  getAllDocumentTypes() {
    this.VDService.getDocumentTypes()
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: ImagilityBaseResponse) => {
        this.listDocumentReferenceData = Object.assign([], response.data);
      });
  }
  addMoreColumns() {
    this.palette.gridProperties.push({
      columnName: '',
      columnDef: '',
      columnType: '',
      columnOption: '',
      hideFromList: false
    });
  }
  onChangeColType(e, palette) {
    if (e.target.value === 'dropdown') {
      palette.properties = {
        inputArray: ['Sample 1'],
        isDataFromApi: false,
        isMultiselect: false,
        showDataSelection: true,
        showMultiSelectOption: true,
        refercenceCodeForApiCall: ''
      };
    }
  }

  // handleGridDropedownChange(selectedVlaue,item){
  //   console.log("handleDropDownChange",selectedVlaue,item);
  //   if(selectedVlaue === 'COUNTRY')
  //   this.palette.gridProperties.push({
  //     columnName: 'State',
  //     columnDef: 'state',
  //     columnType: 'text',
  //     columnOption: ''
  //   });

  // }

  // handle upload begin
  uploadIconImage(item) {
    const dialogRef = this.dialog.open(SignatureUploadComponent, {
      panelClass: 'custom-dialog',
      data: 'iconUpload'
    });

    dialogRef.afterClosed().subscribe(result => {
      const file = this.dataURItoBlob(result);
      let userImageForm = new FormData();
      userImageForm.append("file", file, "mycustomIcon" + '_' + this.uuid() + '.png');
      this.VDService.postCustomRadioImage(item.id, userImageForm).subscribe((response) => {
        if (response['status'] === 200) {
          this.toastr.success('Image Uploaded successfully', 'Success');
          this.palette.properties.inputArray.forEach(x => {
            if (x.code === item.code) {
              x.imgUrl = environment.appUrl + response.data.imagePath;
              x.id = response.data.id;
            }
          });
        }
        else {
          CustomErrorToastComponent.showErrorToast(this.toastr, 'Image is not Uploaded successfully');
        }
      });
    });
  } //uploadIconImage func. end
  // handle upload end

  dataURItoBlob(dataURI) {
    const binary = atob(dataURI.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: 'image/png',
    });
  }

}
